module.exports = __webpack_public_path__ + "static/src/content/images/processed/thumb/Into-The-Badlands-S2.c65b253.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/content/images/processed/thumb/Into-The-Badlands-S2.jpg
// module id = yq1A
// module chunks = 0